import { render } from "./VsudAvatar.vue?vue&type=template&id=94d5fbca"
import script from "./VsudAvatar.vue?vue&type=script&lang=js"
export * from "./VsudAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__